import { render, staticRenderFns } from "./TextAlignCenter.vue?vue&type=template&id=89638a14&scoped=true&"
import script from "./TextAlignCenter.vue?vue&type=script&lang=js&"
export * from "./TextAlignCenter.vue?vue&type=script&lang=js&"
import style0 from "./TextAlignCenter.vue?vue&type=style&index=0&id=89638a14&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89638a14",
  null
  
)

export default component.exports